import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "i-preloader__item" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "g-row g-row--appearance_spaced g-row--space_xl-xl" }
const _hoisted_4 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_5 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_6 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_7 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_8 = { class: "error-label" }
const _hoisted_9 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_10 = { class: "error-label" }
const _hoisted_11 = { class: "ds-panel ds-panel--space_3xl ds-panel--space_6xl-xl" }
const _hoisted_12 = { class: "ds-panel__element ds-panel__element--offset_top" }
const _hoisted_13 = { class: "ds-panel ds-panel--space_xl" }
const _hoisted_14 = { class: "ds-panel__element ds-panel__element--offset_top" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_control_input = _resolveComponent("control-input")!
  const _component_VeeError = _resolveComponent("VeeError")!
  const _component_control_button = _resolveComponent("control-button")!
  const _component_VeeForm = _resolveComponent("VeeForm")!

  return (_openBlock(), _createBlock(_component_VeeForm, { onSubmit: $setup.send }, {
    default: _withCtx(({ errors }) => [
      _createElementVNode("div", {
        class: _normalizeClass(["i-preloader", { 'is-active': $setup.isLoad }])
      }, _hoisted_2, 2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_control_input, {
            class: "d-control-descriptor--variant_1",
            "input-class": "d-control-input--variant_1",
            name: "name",
            type: "text",
            rules: "required|max:255",
            modelValue: $setup.formdata.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.formdata.name) = $event)),
            errors: errors,
            placeholder: $setup.$t("Ваше ім'я")+"*"
          }, null, 8, ["modelValue", "errors", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_control_input, {
            class: "d-control-descriptor--variant_1",
            "input-class": "d-control-input--variant_1",
            name: "contact",
            modelValue: $setup.formdata.contact,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.formdata.contact) = $event)),
            errors: errors,
            placeholder: $setup.$t("Ел. пошта або номер телефону")+"*",
            type: "text",
            rules: "required|emailOrPhone|max:255"
          }, null, 8, ["modelValue", "errors", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_control_input, {
            class: "d-control-descriptor--variant_1",
            "input-class": "d-control-input--variant_1",
            component: "SimpleTextarea",
            name: "message",
            rows: "1",
            rules: "min:5|max:1000",
            errors: errors,
            placeholder: $setup.$t("Введіть ваше повідомлення"),
            modelValue: $setup.formdata.message,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.formdata.message) = $event))
          }, null, 8, ["errors", "placeholder", "modelValue"])
        ]),
        _createVNode(_component_VeeError, { name: "non_field_errors" }, {
          default: _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(message), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_VeeError, { name: "recaptcha" }, {
          default: _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString($setup.$t("ReCaptcha -")) + " " + _toDisplayString(message), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_control_button, {
            disabled: $setup.isLoad,
            type: "submit"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.$t("Надіслати")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode($setup["PrivacyPolicy"], {
            text: $setup.$t("Надсилаючи форму, Ви погоджуєтесь з")
          }, null, 8, ["text"])
        ])
      ])
    ]),
    _: 1
  }))
}